var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "matrix(1 0 0 -1 0 16)",
    fill: "#3299FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4089 10.3911C12.3638 10.4997 12.2775 10.586 12.1689 10.6311C12.1155 10.6538 12.0581 10.6659 12 10.6666H9.77778C9.6599 10.6666 9.54686 10.6198 9.46351 10.5365C9.38016 10.4531 9.33333 10.3401 9.33333 10.2222C9.33333 10.1043 9.38016 9.99126 9.46351 9.90791C9.54686 9.82456 9.6599 9.77774 9.77778 9.77774H10.9289L8.44444 7.29329L6.98222 8.75996C6.94091 8.80162 6.89175 8.83468 6.83759 8.85724C6.78343 8.87981 6.72534 8.89143 6.66667 8.89143C6.60799 8.89143 6.5499 8.87981 6.49574 8.85724C6.44158 8.83468 6.39243 8.80162 6.35111 8.75996L3.68444 6.09329C3.64279 6.05198 3.60972 6.00282 3.58716 5.94866C3.5646 5.8945 3.55298 5.83641 3.55298 5.77774C3.55298 5.71907 3.5646 5.66097 3.58716 5.60681C3.60972 5.55266 3.64279 5.5035 3.68444 5.46218C3.72576 5.42053 3.77492 5.38746 3.82908 5.3649C3.88324 5.34233 3.94133 5.33072 4 5.33072C4.05867 5.33072 4.11676 5.34233 4.17092 5.3649C4.22508 5.38746 4.27424 5.42053 4.31556 5.46218L6.66667 7.81774L8.12889 6.35107C8.17021 6.30941 8.21936 6.27635 8.27352 6.25379C8.32768 6.23122 8.38577 6.2196 8.44444 6.2196C8.50312 6.2196 8.56121 6.23122 8.61537 6.25379C8.66953 6.27635 8.71868 6.30941 8.76 6.35107L11.5556 9.15107V7.99996C11.5556 7.88209 11.6024 7.76904 11.6857 7.68569C11.7691 7.60234 11.8821 7.55552 12 7.55552C12.1179 7.55552 12.2309 7.60234 12.3143 7.68569C12.3976 7.76904 12.4444 7.88209 12.4444 7.99996V10.2222C12.4437 10.2803 12.4317 10.3376 12.4089 10.3911Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/trendDown.2a0c59bf14c8680ab6315e1a37a2f907.svg";
export { ForwardRef as ReactComponent };